import { Star, ExternalLink } from "lucide-react";
import { Reveal, Chapter } from "./shared";

const Reviews = () => (
  <section id="reviews" className="py-16 sm:py-24 lg:py-28" data-testid="reviews-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-6">
      <Chapter num="06" label="Client Results" />

      <Reveal delay={0.1} className="flex gap-1.5 text-[#c99a43]">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={20} fill="currentColor" strokeWidth={0} />
        ))}
      </Reveal>

      <Reveal delay={0.18}>
        <blockquote
          data-testid="review-quote"
          className="font-serif italic text-2xl sm:text-3xl lg:text-4xl text-[#16324a] leading-snug tracking-tight"
        >
          <span className="text-[#c99a43] not-italic">&ldquo;</span>
          My old website looked good but was not appearing on Google search. Chesco Local
          Presence built a beautiful new site with easy click to call and within a week customers
          could find us on Google. When I want to change or update the site, I just send an
          email or text and they take care of it. Amazing service &amp; value!
          <span className="text-[#c99a43] not-italic">&rdquo;</span>
        </blockquote>
      </Reveal>

      <Reveal delay={0.26} className="flex flex-col items-center gap-1.5">
        <p data-testid="review-author" className="font-sans font-bold text-[#16324a]">
          Roger Minner
        </p>
        <p className="text-sm text-[#627d98]">Realtor &middot; Kennett Square, PA</p>
        <a
          data-testid="review-website-link"
          href="https://rogerminnerhomes.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 mt-1 text-sm font-semibold text-[#a37d3f] hover:text-[#16324a] transition-colors duration-300 border-b border-[#e8c78f] hover:border-[#16324a] pb-0.5"
        >
          rogerminnerhomes.com <ExternalLink size={13} />
        </a>
      </Reveal>
    </div>
  </section>
);

export default Reviews;
